module.exports = __webpack_public_path__ + "img/slide3.48fef884.jpg";